<template>
    <Modal :alwaysShow="true" header="Add Item to Watch List" @hide="$emit('hide')">
        <div class="pull-right">
            <button class="btn btn-default btn-xs" @click="showNewWatchListDialog = true">
                Add new Watch List
            </button>
        </div>

        <FormGroup title="Watch List">
            <select v-model="watchListId" class="form-control" :disabled="saving">
                <option :value="null">(Select)</option>
                <option v-for="watchList in watchLists" :value="watchList.id">{{ watchList.name }}</option>
            </select>
        </FormGroup>

        <template slot="footer">
            <button class="btn btn-primary" @click="save" :disabled="!watchListId || saving">Add to Watch List</button>
        </template>

        <WatchListDialog
            v-if="showNewWatchListDialog"
            @saved="handleNewWatchList"
            @hide="showNewWatchListDialog = false"
            ></WatchListDialog>
    </Modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        WatchListDialog: require('@/components/watchLists/WatchListDialog.vue').default,
    },
    props: ['amazonProductId'],
    data() {
        return {
            saving: false,
            watchListId: null,
            showNewWatchListDialog: false,
        };
    },
    computed: {
        ...mapState('data', {
            watchLists(state) { return _.orderBy(state.watchLists.byId, [watchList => watchList.name.toLowerCase()]); },
        }),
    },
    created() {
        this.getWatchLists();
    },
    methods: {
        ...mapActions('data', ['getWatchLists', 'addAmazonProductToWatchList']),
        async save() {
            this.saving = true;

            try {
                await this.addAmazonProductToWatchList({
                    watchList: { id: this.watchListId },
                    amazonProduct: { id: this.amazonProductId },
                });

                this.$emit('hide');
            }
            catch (e) {
                if (e.response && e.response.status === 422) {
                    swal('Already on watch list', 'This item is already on the selected watch list', 'error');
                }
                else {
                    swal('Couldn\'t add item to watch list', 'Please try again later', 'error');
                }
            }

            this.saving = false;
        },
        handleNewWatchList(watchList) {
            this.watchListId = watchList.id;
        },
    }
}
</script>
